import { ArrowBack, CopyAllOutlined } from "@mui/icons-material";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { ImageField, Link, useRefresh } from "react-admin";
import { useState } from "react";
import {
  Button,
  CheckboxGroupInput,
  DateInput,
  Edit,
  EditButton,
  required,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  Toolbar,
  TopToolbar,
  useRecordContext,
} from "react-admin";
import { useFormContext } from "react-hook-form";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSave from "../../unit/CustomButtonSave";
import HmTextInput from "../../unit/HmTextInput";
import useNotify from "../../unit/useNotify";
import React from "react";
import { format } from "date-fns";
import formatPhone from "../../unit/inputFormat/formatPhone";
import parsePhone from "../../unit/inputFormat/parsePhone";
import YesNoInput3 from "../../unit/YesNoInput3";
import HeaderLabelGridField from "../../unit/HeaderLabelGridField";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import UploadLogoImage from "../../unit/UploadLogoImage";
const LogoEditForm = ({ isEdit = false, admin = false }) => {
  const record = useRecordContext();
  const { success, error, info } = useNotify();
  const refresh = useRefresh();
  if (!record) return <div>Loading...</div>;

  const ShowLogos = ({ ...props }) => {
    const size = props?.size || "large";
    const record = useRecordContext();
    const [logoPath, setLogoPath] = useState(record?.sBankLogo);
    const [logoBcPath, setLogoBcPath] = useState(record?.sBankBcLogo);

    const [filelist, setFilelist] = React.useState<any[]>([]);
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          mb: "20px",
        }}
      >
        {size == "small" && (
          <Typography variant="subtitle1">
            <b>Square logo</b> (as brand image shown on the top banner of
            customer site. Tip: Use logo for Twitter account)
          </Typography>
        )}
        {size != "small" && (
          <Typography variant="subtitle1">
            <b>Rectangular logo</b> (with institution name for Welcome Page and
            legal documents. Tip: Use full logo)
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            mb: "20px",
            "& .RaImageField-image": {
              height: "100px !important",
              width: "auto !important",
              objectFit: "contain",
            },
            "& > div": {
              height: "80px",
              display: "flex",
              alignItems: "center",
            },
          }}
        >
          {size == "small" ? (
            <>
              <Box sx={{ width: "100%", mt: 1 }}>
                {logoBcPath && (
                  <img src={logoBcPath} style={{ maxHeight: "100px" }} />
                )}
              </Box>
              <Box sx={{ width: "250px", mt: 1 }}>
                <UploadLogoImage
                  uploadName="sBankBcLogo"
                  uploadApi={"banks/actions/uploadLogo/" + record?.id}
                  onSuccess={(filelist: any) => {
                    setLogoBcPath(filelist);
                  }}
                  disabled={isEdit ? false : true}
                />
              </Box>
            </>
          ) : (
            <>
              <Box sx={{ width: "100%", mt: 1 }}>
                {logoPath && (
                  <img src={logoPath} style={{ maxHeight: "100px" }} />
                )}
              </Box>

              <div style={{ width: "300px" }}>
                <UploadLogoImage
                  uploadName="sBankLogo"
                  uploadApi={"banks/actions/uploadLogo/" + record?.id}
                  onSuccess={(filelist: any) => {
                    // refresh();
                    setLogoPath(filelist);
                  }}
                  disabled={isEdit ? false : true}
                />
              </div>
            </>
          )}
        </Box>
      </Box>
    );
  };
  return (
    <SimpleForm toolbar={false}>
      <Box
        sx={{
          pt: 1,
          pb: 1,
          width: "100%",
          // backgroundColor: "#fff",
          height: `calc(100vh - 387px)`,
          minHeight: `calc(100vh - 387px)`,
          overflowY: "auto",
        }}
        className="bank_profile_info"
        id="bank_edit_profile_info"
      >
        <ShowLogos />
        <ShowLogos size="small" />
      </Box>
    </SimpleForm>
  );
};

const LogoEdit = () => {
  const [isEditing, setIsEditing] = useState(false);
  const { success, error, info } = useNotify();

  const Actions = () => (
    <TopToolbar>
      {!isEditing ? (
        <EditButton
          onClick={() => setIsEditing(true)}
          sx={{ width: "100px" }}
        />
      ) : (
        <Button
          label="Back"
          onClick={() => {
            setIsEditing(false);
          }}
          sx={{ width: "100px" }}
          startIcon={<ArrowBack />}
        />
      )}
    </TopToolbar>
  );

  const handleSuccess = () => {
    setIsEditing(false);
    success("updated successfully");
  };
  const admin = localStorage.getItem("authrole") == "admin" ? true : false;
  return (
    <Edit
      title="Access"
      actions={<Actions />}
      mutationOptions={{ onSuccess: handleSuccess }}
    >
      {<LogoEditForm isEdit={isEditing} admin={admin} />}
    </Edit>
  );
};

export default LogoEdit;
